import { useEffect, useState, PropsWithChildren, ReactPortal } from 'react';
import { createPortal } from 'react-dom';

import './style.scss';

function getOrCreateModalRootElementIfNotExist(id = 'modalRoot') {
  let elem = document.getElementById(id);

  if (elem) {
    return elem;
  }

  elem = document.createElement('div');
  elem.setAttribute('id', id);

  document.body.appendChild(elem);

  return elem;
}

interface ModalProps {
  modalRootId?: string;
}

export default function Modal(
  props: PropsWithChildren<ModalProps>
): ReactPortal {
  const { children, modalRootId } = props;
  const [modal, setModal] = useState(document.createElement('div'));

  useEffect(() => {
    const modalElem = document.createElement('div');
    modalElem.setAttribute('class', 'modal');

    const modalRoot = getOrCreateModalRootElementIfNotExist(modalRootId);
    modalRoot.appendChild(modalElem);

    setModal(modalElem);

    document.body.style.overflow = 'hidden';

    return () => {
      modalRoot.removeChild(modalElem);
      document.body.style.overflow = 'auto';
    };
  }, []);

  return createPortal(children, modal);
}
